/* eslint-disable @typescript-eslint/camelcase */
export const TRUE = "1";
export const FALSE = "0";
export const INVALID = -9999999;

export const getKeywords = () => ({
    // Function names.
    fn_min: "min",
    fn_max: "max",
    fn_som: "som",
    fn_sum: "sum",
    fn_smr: "smr",
    fn_sm2: "sm2",
    fn_ind: "ind",
    fn_prj: "prj",
    fn_if: "if",
    fn_si: "si",
    fn_v01: "v01",
    fn_nbr: "nbr",
    fn_sgn: "sgn",
    fn_cmp: "cmp",
    fn_cmr: "cmr",
    fn_meq: "meq",
    fn_mnb: "mnb",
    fn_rng: "rng",
    fn_rnk: "rnk",
    fn_sqr: "sqr",
    fn_ln: "ln",
    fn_log: "log",
    fn_abs: "abs",
    fn_trc: "trc",
    fn_ran: "ran",
    fn_mod: "mod",
    fn_exp: "exp",
    fn_jul: "jul",
    fn_yea: "yea",
    fn_mon: "mon",
    fn_day: "day",
    fn_wkd: "wkd",
    fn_qta: "qta",
    fn_qtf: "qtf",
    fn_qtc: "qtc",
    fn_str: "str",
    fn_nbc: "nbc",
    fn_qtisavail: "qtisavail",
    fn_qtareavail: "qtareavail",
    fn_getavailqt: "getavailqt",
    fn_selrandqt: "selrandqt",
    fn_qtisavailresp: "qtisavailresp",
    fn_qtareavailresp: "qtareavailresp",
    fn_getavailqtresp: "getavailqtresp",
    fn_selrandqtresp: "selrandqtresp",
    fn_rnb: "rnb",
    fn_rxy: "rxy",
    fn_nbl: "nbl",
    fn_csm: "csm",
    fn_cmx: "cmx",
    fn_cmn: "cmn",
    fn_cor: "cor",
    fn_can: "can",
    fn_cin: "cin",
    fn_mov: "mov",
    fn_mlb: "mlb",
    fn_mst: "mst",
    fn_mvc: "mvc",
    fn_fsr: "fsr",
    // Boolean keywords.
    not: "not",
    true: "true",
    false: "false",
    and: "and",
    or: "or",
    contains: "contains",
    non: "non",
    ou: "ou",
    et: "et",
});
